import type { ReactNode } from 'react'
import React, { createContext, useContext } from 'react'
import { useShowTemple } from '@fs/zion-permissions'

const ShowTempleContext = createContext<ReturnType<typeof useShowTemple> | null>(null)

export const useShowTempleContext = (): ReturnType<typeof useShowTemple> => {
  const context = useContext(ShowTempleContext)
  if (!context) throw new Error('useShowTempleContext needs to be used inside a ShowTempleProvider.')
  return context
}

// This provider exists to reduce re-renders. Turns out useShowTemple from @fs/zion-permissions causes a re-render each time on mount.
// Since multiple components and multiple levels in the app need to use useShowTemple, this provides it without needing to re-render.
// Temple permissions do not change dynamically while the user is operating, so there is never a need to fetch it more than once.
export default function ShowTempleProvider({ children }: { children: ReactNode }): JSX.Element {
  const value = useShowTemple()
  return <ShowTempleContext.Provider value={value}>{children}</ShowTempleContext.Provider>
}
